export default {"src":"/_next/static/media/edit.3743e0da.svg","height":16,"width":16};